<template>
    <selector-radio-group
    :label="t('recoverCredentials.step3.topMessage')"
    :radioParams="radioList"
    @clicked="radioClickedHandler"/>

    <input-password
    v-if="formData.selectedRadio !== 'acession'"
    :params="newPasswordParams"
    :inputValue="formData.newPassword"
    @input="[emit('formDataChange', { field: 'newPassword', inputValue: $event }), clearFieldError('newPasswordParams')]"
	@onBlur="newPasswordValidation"/>
    <input-password
    v-if="formData.selectedRadio !== 'acession'"
    :params="newPasswordConfirmParams"
    :inputValue="formData.newPasswordConfirmation"
    @input="[emit('formDataChange', { field: 'newPasswordConfirmation', inputValue: $event }), clearFieldError('newPasswordConfirmParams')]"
	@onBlur="newPasswordValidation"/>
</template>

<script setup>
import SelectorRadioGroup from '@/components/generic/selectors/radio/RadioGroup'
import InputPassword from '@/components/generic/inputs/Password'

/* Vue */
import { ref, computed, watch } from 'vue'

/* Assets */
import { NUMBERS_ONLY } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['formDataChange', 'clearStep3'])

const props = defineProps({
    formData: Object,
    mandatoryList: Array,
    showMandatoryErrors: Boolean,
    clearFormErrors: Boolean
})

const radioList = computed(() => {
    return [{
        id: 'acession',
        text: t('recoverCredentials.step3.acessionRadio'),
        selected: props.formData.selectedRadio === 'acession'
    }, {
        id: 'password',
        text: t('recoverCredentials.step3.passwordRadio'),
        selected: props.formData.selectedRadio === 'password'
    }, {
        id: 'acessionAndPassword',
        text: t('recoverCredentials.step3.acessionAndPasswordRadio'),
        selected: props.formData.selectedRadio === 'acessionAndPassword'
    }]
})

const newPasswordParams = ref({
    labelText: t('recoverCredentials.step3.newPasswordLabel'),
    placeholder: t('recoverCredentials.step3.newPasswordPlaceholder'),
    maxLength: 6,
    mandatory: true,
    errorState: false,
    errorMessage: '',
    mask: NUMBERS_ONLY
})

const newPasswordConfirmParams = ref({
    labelText: t('recoverCredentials.step3.newPasswordConfirmationLabel'),
    placeholder: t('recoverCredentials.step3.newPasswordConfirmationPlaceholder'),
    maxLength: 6,
    mandatory: true,
    errorState: false,
    errorMessage: '',
    mask: NUMBERS_ONLY
})

const radioClickedHandler = event => {
    emit('formDataChange', { field: 'selectedRadio', inputValue: event })
    emit('clearStep3')
}

/**********************************************************************
*                                                                     *
*                        MANDATORY FIELDS LOGIC                       *
*                                                                     *
**********************************************************************/
const newPasswordValidation = () => {
    if (!props.formData.newPassword.length && !props.formData.newPasswordConfirmation.length) return

	// se a nova password for diferente da confirmação, ativa o erro e a mensagem dos dois
	if (props.formData.newPassword !== props.formData.newPasswordConfirmation) {
        if (!!props.formData.newPassword.length && !!props.formData.newPasswordConfirmation.length) {
            newPasswordParams.value.errorState = true
            newPasswordParams.value.errorMessage = t('userArea.definitions.passwordChange.passwordNonEqual')
            newPasswordConfirmParams.value.errorState = true
            newPasswordConfirmParams.value.errorMessage = t('userArea.definitions.passwordChange.passwordNonEqual')
        }
	} else {
		clearFieldError('newPasswordParams')
		clearFieldError('newPasswordConfirmParams')
	}
}

const allFormFields = ref({
	newPasswordParams: newPasswordParams.value,
	newPasswordConfirmParams: newPasswordConfirmParams.value
})

watch(() => props.showMandatoryErrors, newValue => {
	if (newValue) showMandatoryErrorsHandler()
    emit('resetShowMandatoryErrorsProp')
})

const showMandatoryErrorsHandler = () => {
	if (props.formData.selectedRadio !== 'acession') {
        if (!props.formData.newPassword) {
            newPasswordParams.value.errorState = true
            newPasswordParams.value.errorMessage = t('mandatoryFieldError')
        }

        if (!props.formData.newPasswordConfirmation) {
            newPasswordConfirmParams.value.errorState = true
            newPasswordConfirmParams.value.errorMessage = t('mandatoryFieldError')
        }
    }
}

/**********************************************************************
*                                                                     *
*                          CLEAR ERRORS LOGIC                         *
*                                                                     *
**********************************************************************/
watch(() => props.clearFormErrors, () => {
    clearFormErrors()
    emit('formErrorsCleared')
})

const clearFieldError = (fieldName) => {
    allFormFields.value[fieldName].errorMessage = null
    allFormFields.value[fieldName].errorState = false
}

const clearFormErrors = () => {
    for (var fieldName in allFormFields.value) {
        clearFieldError(fieldName)
    }
}
</script>

<style lang="scss" scoped>
.text {
    @include H5-Regular;
    color: var(--secondary-dark-2);
}
</style>
